import * as React from "react";
import type { GatsbyBrowser } from "gatsby";
import { AuthProvider } from "./src/context/AuthContext";

export const wrapRootElement: GatsbyBrowser["wrapRootElement"] = ({
  element,
}) => <AuthProvider>{element}</AuthProvider>;
